export default __webpack_public_path__ + "static/media/Image_not_available.70ac66a4.png";